import { Checkbox, Grid, Paper } from "@material-ui/core";
import { useState, useEffect, useCallback, useContext, Suspense, useRef } from "react";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import EventNoteIcon from "@material-ui/icons/EventNote";

import "./PDForm.css";
import { AuthContext, PaycheckContext, ThemeContext } from "../../../../../../../../contexts";
import PlanHeader from "../../../../../../../shared/enrollment/planCode/PlanHeader";
import { CustomInput } from "../../../../../../../shared/customInput";
import { Button } from "@material-ui/core";
import { dollarize } from "../../../../../../../../utils/commonFunctions/dollar";
import { dateTimeZoneConverter, getCurrentDate } from "../../../../../../../../utils/commonFunctions/date";
import { EnrollmentSchema } from "../../../../../../../../@types/enrollment.types copy";
import { Validation } from "../../../../../../../../@types/validation.types";
import { AdminEnrollmentInitDataQuery } from "../../../../../../../../utils/api/pages/enrollmentInit";
import useRouteParam from "../../../../../../../../hooks/useRouteParam";
import { Enrollment } from "../../../../../../../../@types/enrollment.types";
import { api } from "../../../../../../../../utils/api";
import { ApproveHOOEnrollment } from "../../../../../../../../@types/components/enrollmentProps.types";
import { LazyApproveEnrollment } from "../../../../../..";
import { Member } from "../../../../../../../../@types/member.types";
import { helpingOurOwnLogo } from "../../../../../../../../assets";
import { ApproveHOOEnrollmentPayload } from "../../../../../../../../utils/api/enrollment/enrollment";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { useNavigate } from "react-router-dom";
import { trackPromise } from "react-promise-tracker";

import SendIcon from "@material-ui/icons/Send";
import encryption from "../../../../../../../../utils/commonFunctions/encryption";
import { ENROLLMENT_STATUS } from "../../../../../../../../constants/enrollment/enrollmentStatus";

const PDForm = (): JSX.Element => {
	const { theme, setTheme } = useContext(ThemeContext);
	const navigate = useNavigate();
	const { paycheck, setPaycheck } = useContext(PaycheckContext);
	const [enrollmentDate, setEnrollmentDate] = useState("");
	const [member, setMember] = useState<Member | null>(null);
	const [approveHOOEnrollment, setApproveHOOEnrollment] = useState<ApproveHOOEnrollment>();
	const [HOOEnrollment, setHOOEnrollment] = useState<Enrollment | null>(null);
	const queryPlanCode = useRouteParam("pc");
	const queryGroupNumber = useRouteParam("gn");
	const querySSN = useRouteParam("qs");
	const [premiumAmount, setPremiumAmount] = useState<number | null>(null);
	const [validation, setValidation] = useState<Validation>({
		approveHOOEnrollment: {},
		status: "invalid"
	});
	const _validation = useRef<Validation>();

	const handleApproveHOOEnrollmentChange = useCallback(
		(
			event: React.ChangeEvent<
				| HTMLInputElement
				| {
						name?: string | undefined;
						value: unknown;
				  }
			>,
			child?: React.ReactNode
		) => {
			const { name, value } = event.target;
			setApproveHOOEnrollment(
				Object.assign({}, approveHOOEnrollment, {
					[name as string]: value
				})
			);
		},
		[approveHOOEnrollment]
	);

	const handleValidation = useCallback(async () => {
		_validation.current = {
			...validation,
			approveHOOEnrollment: {},
			status: "invalid"
		};
		let flag = true;

		// console.log("In handle Validation", approveHOOEnrollment);

		if (approveHOOEnrollment === undefined) {
			_validation.current["status"] = "invalid";
			flag = false;
		}

		if (
			(approveHOOEnrollment?.enrollment_status !== "ACTIVE" &&
				approveHOOEnrollment?.enrollment_status !== "REJECTED") ||
			approveHOOEnrollment?.enrollment_status.length === 0
		) {
			_validation.current.approveHOOEnrollment["enrollment_status"] = "Enrollment Status is required";
			_validation.current.status = "invalid";
			flag = false;
		}

		if (approveHOOEnrollment?.enrollment_status === "ACTIVE" && !approveHOOEnrollment?.effective_date) {
			_validation.current.approveHOOEnrollment["effective_date"] =
				"For active enrollment effective date is required";
			_validation.current.status = "invalid";
			flag = false;
		}

		if (flag === true) _validation.current["status"] = "valid";
		else {
			_validation.current["status"] = "invalid";
			// alert("Please, fill effective date field !");
		}
		setValidation(Object.assign({}, _validation.current));
		return _validation.current.status;
	}, [approveHOOEnrollment, validation]);

	const handleMemberDetailsRedirection = useCallback(() => {
		const pathname = `/employer/member?gn=${queryGroupNumber}&&qs=${
			encryption(querySSN as string) as string
		}&&to=benefits`;
		navigate(pathname);
	}, [navigate, queryGroupNumber, querySSN]);

	const handleSubmitEnrollmentClick = useCallback(
		async (event: React.FormEvent<HTMLButtonElement>) => {
			// console.log("approve", approveHOOEnrollment);
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			const validation = await handleValidation();
			// console.log("validation", validation);
			if (validation === "valid") {
				if (approveHOOEnrollment === undefined) {
					return;
				}

				const { effective_date } = approveHOOEnrollment;

				const effectiveDate = new Date(effective_date as unknown as Date);

				const approveHOOEnrollmentPayload: ApproveHOOEnrollmentPayload = {
					...approveHOOEnrollment,
					effective_date:
						effectiveDate.getFullYear() +
						"-" +
						(effectiveDate.getMonth() + 1) +
						"-" +
						effectiveDate.getDate()
				};
				const response = await trackPromise(api.enrollments.approveHOOEnrollment(approveHOOEnrollmentPayload));

				// console.log("response", response);
				if (response) {
					const { enrollment_status } = response;

					enrollment_status === ENROLLMENT_STATUS.active
						? alert("Helping Our Own launch enrollment Submitted!")
						: enrollment_status === ENROLLMENT_STATUS.rejected
						? alert("Helping Our Own launch enrollment has been Rejected!")
						: alert(null);

					handleMemberDetailsRedirection();
				}
			}
			// if (approveHOOEnrollment === undefined) {
			// 	return;
			// }
			// const approveHOOEnrollmentPayload: ApproveHOOEnrollmentPayload = approveHOOEnrollment;
			// const response = await api.enrollments.approveHOOEnrollment(approveHOOEnrollmentPayload);
			// if (response) {
			// 	navigate(-1);
			// }
		},
		[approveHOOEnrollment, handleMemberDetailsRedirection, handleValidation]
	);

	// const handleApproveEnrollmentDateChange = useCallback(
	// 	(date?: MaterialUiPickersDate, value?: string | null | undefined) => {
	// 		const selectedDate = new Date(date as any);

	// 		const parsedDate =
	// 			selectedDate.getFullYear() + "-" + (selectedDate.getMonth() + 1) + "-" + selectedDate.getDate();

	// 		setApproveHOOEnrollment(
	// 			Object.assign({}, approveHOOEnrollment, {
	// 				effective_date: parsedDate
	// 			})
	// 		);
	// 	},
	// 	[approveHOOEnrollment]
	// );

	const handleApproveEnrollmentDateChange = useCallback(
		(date?: MaterialUiPickersDate, value?: string | null | undefined) => {
			const parsedDate = date as unknown as string;
			setApproveHOOEnrollment(Object.assign({}, approveHOOEnrollment, { effective_date: parsedDate }));
		},
		[approveHOOEnrollment]
	);

	const getAdminEnrollmentInitData = useCallback(async () => {
		if (!queryGroupNumber || !queryPlanCode || !querySSN) {
			return;
		}
		//getAdminEnrollmentInitData();
		const query: AdminEnrollmentInitDataQuery = {
			insured_SSN: querySSN as string,
			plan_code: queryPlanCode as string,
			group_number: queryGroupNumber as number
		};
		const { theme, enrollments, paycheck } = await trackPromise(api.pages.getAdminEnrollmentInitData(query));
		setHOOEnrollment(Object.assign({}, enrollments[0]));
		setApproveHOOEnrollment(
			Object.assign(
				{},
				{
					group_number: queryGroupNumber as number,
					current_paycheck_id: paycheck._id as string,
					_id: enrollments[0]._id as string,
					plan_code: enrollments[0].plan_code,
					insured_SSN: enrollments[0].employee?.SSN as string,
					premium_amount: enrollments[0].premium_amount,
					effective_date: enrollments[0].effective_date
						? (enrollments[0].effective_date as unknown as string)
						: null,
					enrollment_status: enrollments[0].enrollment_status
				}
			)
		);
		// console.log("enrollments[0]", enrollments[0].enrollment_date);
		setEnrollmentDate(enrollments[0].enrollment_date as unknown as string);
		setMember(Object.assign({}, enrollments[0].employee));
		setTheme(Object.assign({}, theme));
		setPaycheck(Object.assign({}, paycheck));
	}, [queryGroupNumber, queryPlanCode, querySSN, setPaycheck, setTheme]);

	useEffect(() => {
		getAdminEnrollmentInitData();
	}, [getAdminEnrollmentInitData]);

	return (
		<Suspense fallback={<div />}>
			<div className="PDForm-container theme-container">
				<Paper className="paper-container">
					<div className="header-image-container">
						<PlanHeader
							planCode={queryPlanCode as string}
							planName="Helping Our Own"
							// planName="Payroll Deduction Form"
							planLogo={helpingOurOwnLogo}
						/>
					</div>
					<div className="theme-plan-section-margin" />
					<div className="theme-plan-icon-item-container">
						<div>
							<CreateOutlinedIcon className="theme-plan-point-icon" />
						</div>
						<div className="theme-plan-point-text">
							The Brookshire Brothers Helping Our Own fund provides support to fellow Employee Owners who
							have suffered a significant financial hardship due to a house fire, natural disaster, family
							death, medical expenses or other unforeseen events.
						</div>
					</div>
					<br></br>
					<div className="theme-plan-icon-item-container">
						<div>
							<CreateOutlinedIcon className="theme-plan-point-icon" />
						</div>
						<div className="theme-plan-point-text">
							The fund enables you as an employee to provide support for your fellow Employee Owners
							during their time of need. You can opt to give either weekly or monthly through payroll
							deduction. All donations further the purposes of the Helping Our Own fund in its programs
							and operations to assist &quot;our own&quot; Brookshire Brothers employees
						</div>
					</div>
					<br></br>
					<div className="theme-plan-icon-item-container">
						<div>
							<CreateOutlinedIcon className="theme-plan-point-icon" />
						</div>
						<div className="theme-plan-point-text">
							All emplayers are eligible to apply, whether or not they donate to the Helping Our Own fund.
							Applications are strictly conlidential. Assistance granted is a gilt, not a loan. There is
							no expectation of re-payment.
						</div>
					</div>
					<Grid container className="theme-plan-section-margin">
						<Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
							<div className="details-form-row">
								<div className="details-form-label  required">Employee ID</div>
								<CustomInput value={member?.member_id} />
							</div>
						</Grid>
						<Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
							<div className="details-form-row">
								<div className="details-form-label">First Name</div>
								<CustomInput value={member?.first_name} />
							</div>
						</Grid>
						<Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
							<div className="details-form-row">
								<div className="details-form-label">Last Name</div>
								<CustomInput value={member?.last_name} />
							</div>
						</Grid>
						<Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
							<div className="details-form-row">
								<div className="details-form-label">Date</div>
								<CustomInput value={getCurrentDate()} />
							</div>
						</Grid>
						<Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
							<div className="details-form-row">
								<div className="details-form-label">Department</div>
								<CustomInput value={HOOEnrollment?.location_name} />
							</div>
						</Grid>
					</Grid>
					<div className="details-form-row" style={{ marginTop: "2rem", width: "100%" }}>
						<div className="details-form-label  required">
							The following amount of payment per applicable payroll period (minimum $ 5 per month or $
							1.00 per week) are to be deducted through Brookshire Brothers, Inc. Payroll for the purpose
							of depositing the funds into the Helping our own fund.)
						</div>
						{approveHOOEnrollment ? (
							<CustomInput value={dollarize(approveHOOEnrollment?.premium_amount)} disabled />
						) : null}
					</div>
					<div className="theme-plan-section-margin" />
					<div className="theme-plan-icon-item-container">
						<div>
							<EventNoteIcon className="event-icon" style={{ color: theme.primary_color }} />
						</div>
						<div className="theme-plan-text">
							<strong>Note:</strong> Employee represents that this authorization is executed voluntarily
							and has been made as a conditional of his/her continued employment.
						</div>
					</div>
					<div className="theme-plan-option-content theme-plan-section-margin">
						<Checkbox defaultChecked style={{ paddingLeft: 0 }} />
						<p className="theme-plan-checkbox-label">
							<strong>
								I UNDERSTAND AND AGREE TO THE TERMS AND CONDITIONS STATED ABOVE AND AUTHORIZE
								THE&nbsp;PAYROLL DEDUCTIONS TO BE MADE AS INDICATED
							</strong>
						</p>
					</div>
					<div className="theme-plan-section-margin" />
					<Grid container className="theme-plan-section-margin">
						<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
							<div className="details-form-row">
								<div className="details-form-label  required">Signature</div>
								<CustomInput value={member?.first_name + " " + member?.last_name} disabled />
							</div>
						</Grid>
						<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
							<div className="details-form-row">
								<div className="details-form-label  required">Date</div>
								{approveHOOEnrollment ? (
									<CustomInput
										value={dateTimeZoneConverter(
											approveHOOEnrollment
												? new Date(enrollmentDate).toLocaleDateString()
												: getCurrentDate()
										)}
										disabled
									/>
								) : null}
							</div>
						</Grid>
					</Grid>
					<div className="theme-plan-section-margin" />
					<div className="theme-plan-icon-item-container">
						<div>
							<EventNoteIcon className="event-icon" style={{ color: theme.primary_color }} />
						</div>
						<div className="theme-plan-text">
							<strong>Note:</strong> PLEASE MAIL THE COMPLETED DEDUCTION FORM TO BROOKSHARE BROTHERS HUMAN
							RESOURCE DEPARTMENT
						</div>
					</div>
					<div className="theme-plan-section-margin" />
					{approveHOOEnrollment ? (
						<>
							<Suspense fallback={<div />}>
								<LazyApproveEnrollment
									handleApproveEnrollmentDateChange={handleApproveEnrollmentDateChange}
									enrollmentDate={enrollmentDate}
									approveEnrollment={approveHOOEnrollment}
									handleApproveEnrollmentChange={handleApproveHOOEnrollmentChange}
									validation={validation}
								/>
							</Suspense>
							<div className="theme-plan-section-margin" />
							<div className="enrollment-submit-button-container" id="enrollment-submit-button-container">
								<Button
									className="button-green"
									onClick={handleSubmitEnrollmentClick}
									variant="contained"
									style={{
										pointerEvents: "unset"
									}}
								>
									<span className="button-label-with-icon">Submit</span>
									<span>
										<SendIcon className="button-icon" />
									</span>
								</Button>
							</div>
						</>
					) : null}
				</Paper>
			</div>
		</Suspense>
	);
};

export default PDForm;
